
<template>
  <div class="img_load">
    <img v-if="imgUrl&&success" :src="nImgUrl" @load="loadFunc" @error="imgLoadError" @click="openImageInNewTab" alt />
    <div v-if="!imgUrl" class="alert">暂无图片</div>
    <div v-if="!success" class="alert">{{ text }}</div>
    <Spin fix v-if="loading"></Spin>
  </div>
</template>


<style lang="scss" scoped>
.img_load {
  width: 100%;
  height: 100%;
  text-align: center;
  position: relative;
  img {
    height: 100%;
  }
  .alert {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

<script>
export default {
  data() {
    return {
      loading: false,
      text: "",
      success: true
    };
  },
  computed: {
    nImgUrl() {
      this.loading = true;
      return this.imgUrl;
    }
  },
  props: ["imgUrl"],
  methods: {
    loadFunc() {
      this.success = true;
      this.loading = false;
    },
    imgLoadError() {
      this.success = false;
      this.loading = false;
      this.text = "TnT加载失败";
    },
    openImageInNewTab() {
      window.open(this.imgUrl, '_blank');
    }
  }
};

</script>